var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Mask")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.49990299,2.84217094e-14 C10.5471385,2.84217094e-14 12.5170626,0.938907924 14.3507463,2.49979995 C15.4608581,3.4447637 16.3027342,4.41581913 16.8053974,5.12121956 C17.0648127,5.48500839 17.0648127,5.9763837 16.805362,6.34052874 C16.300493,7.04834517 15.460761,8.01687802 14.3507438,8.96174866 C12.5170396,10.5226373 10.5471298,11.4615385 8.49990299,11.4615385 C6.45266569,11.4615385 4.48270286,10.5226244 2.64900367,8.96174072 C1.53878166,8.01669618 0.694380978,7.04271125 0.194080298,6.33985793 C-0.0647290233,5.9760485 -0.0647290233,5.48529761 0.194293907,5.12118815 C0.69658368,4.41621712 1.5388793,3.44471623 2.64900743,2.4997705 C4.48272684,0.938900822 6.45267517,2.84217094e-14 8.49990299,2.84217094e-14 Z M8.34612692,3.34615385 C7.11610369,3.34615385 6.11535792,4.34689962 6.11535792,5.57692285 C6.11535792,6.80694607 7.11610369,7.80769185 8.34612692,7.80769185 C9.57615015,7.80769185 10.5768959,6.80694607 10.5768959,5.57692285 C10.5768959,4.34689962 9.57615015,3.34615385 8.34612692,3.34615385 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols123",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-preview",
    transform: "translate(-4.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color6",
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-212",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask12",
    fill: "#393D4C",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview.1be657ee.svg";
export { ForwardRef as ReactComponent };